export default "<router-outlet></router-outlet>\n<app-support-button></app-support-button>";